import { createI18nText } from '@hilma/netina2all';

const stationRegistrationFormText = createI18nText({
	he: {
		title: 'פתיחת תחנת חלוקה חדשה',
		labels: {
			fullName: 'שם מלא',
			email: 'כתובת מייל',
			phone: 'טלפון נייד',
			additionalPhone: 'טלפון נייד נוסף (רשות)',
			address: 'כתובת מלאה (עיר, רחוב, מספר בית)',
			send: 'שלח',
			area: 'אזור'
		},
		popUp: {
			title: 'הטופס נשלח בהצלחה!',
			text: 'נחזור אליך בהקדם עם פרטים נוספים'
		},
		noOptions: 'אין אפשרויות'
	},
	en: {
		title: 'Register a Distribution Station',
		labels: {
			fullName: 'Full Name',
			email: 'Email Address',
			phone: 'Cellphone Number',
			additionalPhone: 'Additional Cellphone Number (Optional)',
			address: 'Full Address (City/ District, Street, House Number)',
			send: 'Send',
			area: 'Area'
		},
		popUp: {
			title: 'The form has been submitted successfully!',
			text: "We'll contact you shortly with additional information"
		},
		noOptions: 'No options'
	}
});

export default stationRegistrationFormText;